import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, DateField, List, TextField, FunctionField, NumberField } from 'react-admin';
import IdField from 'components/IdField';
import EnumField from 'components/Enum/EnumField';
import LinkField from 'components/LinkField';
import MoneyField from 'components/MoneyField';
import {
  displayShiftTypes,
  displayWorkdays,
  displayLabels,
  displayPositions,
} from 'resources/professional_saas_details/utils';

const ProfessionalSaasDetailsList = () => (
  <List exporter={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <IdField />
      <LinkField source="professional_id" />
      <NumberField
        label="Max Weekly Hours"
        source="max_weekly_hours"
        options={{ maximumFractionDigits: 2 }}
      />
      <MoneyField label="Hourly Rate" source="hourly_rate_cents" />
      <FunctionField
        label="Shift Types"
        render={(record) => displayShiftTypes(record?.shift_types)}
      />
      <EnumField label="Employment Type" source="employment_type" />
      <DateField label="Offboarded At" source="offboarded_at" />
      <TextField label="Offboarded Reason" source="offboarded_reason" />
      <NumberField label="Preferred Weekly Total Shifts" source="preferred_weekly_total_shifts" />
      <FunctionField
        label="Preferred Workdays"
        render={(record) => displayWorkdays(record?.preferred_workdays)}
      />
      <FunctionField
        label="Preferred Job Slots"
        render={(record) => displayLabels(record?.preferred_job_slots)}
      />
      <FunctionField
        label="Preferred Positions"
        render={(record) => displayPositions(record?.preferred_positions)}
      />
      <FunctionField
        label="Preferred Locations"
        render={(record) => displayLabels(record?.preferred_locations)}
      />
      <DateField label="Preferences Last Updated At" source="preferences_last_updated_at" />
      <LinkField
        label="Preferences Updated By"
        source="preferences_last_updated_by_account_id"
        typename="Account"
      />
    </Datagrid>
  </List>
);

ProfessionalSaasDetailsList.query = gql`
  query GET_LIST($input: ProfessionalSaasDetailQueryInput) {
    _professionalSaasDetailsMeta(input: $input) {
      count
    }
    professionalSaasDetails(input: $input) {
      id
      max_weekly_hours
      hourly_rate_cents
      shift_types
      employment_type
      offboarded_at
      offboarded_reason
      professional_id
      preferred_weekly_total_shifts
      preferred_workdays
      preferred_job_slots {
        id
        label
      }
      preferred_positions {
        id
        display_name
      }
      preferred_locations {
        id
        label
      }
      preferences_last_updated_at
      preferences_last_updated_by_account_id
    }
  }
`;

export default ProfessionalSaasDetailsList;
